import React from 'react';
import { Icon } from '@soluto-design/react';
import Link from '@soluto-design/link';
import cls from '@soluto-design/styles/cls';

export interface AccordionViewMoreProps {
    onClick?: () => void;
    label: string;
    isOpen?: boolean;
    href?: string;
}

const AccordionViewMore: React.FC<AccordionViewMoreProps> = ({
    onClick,
    label,
    isOpen,
    href,
}) => {
    const className = cls(
        'display-xs-flex !no-underline !font-regular justify-xs-center bg-background-secondary rounded-medium hover:bg-background-brand-primary flex items-center justify-center gap-8 text-start px-40 py-16 text-b300 text-text-primary w-full',
        !href &&
            !onClick &&
            '!bg-background-disabled !text-text-disabled focus-visible:outline-0',
    );

    return href ? (
        <Link
            className={className}
            href={href}
            {...(onClick && {
                onClick: (e: any) => {
                    e.preventDefault();
                    onClick();
                },
            })}>
            <span>{label}</span>
            <Icon
                icon={
                    isOpen
                        ? 'arrow-chevron--type-up'
                        : 'arrow-chevron--type-down'
                }
                className="text-[24px]"
            />
        </Link>
    ) : (
        <button className={className} onClick={onClick}>
            <span>{label}</span>
            <Icon
                icon={
                    isOpen
                        ? 'arrow-chevron--type-up'
                        : 'arrow-chevron--type-down'
                }
                className="text-[24px]"
            />
        </button>
    );
};

export default AccordionViewMore;
